import React, { lazy } from 'react';
import { AppRoute } from '../routes.types';
import Profile from '../../containers/UserPages/Profile/Profile';
import AnnouncementsTable from '../../containers/Announcements/AnnouncementsTable';
import StandardizationServicesPage from '../../containers/StandardizationServicesPage/StandardizationServicesPage';

const Notifications = lazy(() => import('../../containers/Dashboard/Notifications/Notifications'));
const AuditLogs = lazy(() => import('../../containers/AuditLogs/AuditLogsHost'));
const VenueSelection = lazy(() => import('../../venues/pages/VenueSelectionPage/VenueSelectionPage'));
const Dashboard = lazy(() => import('../../containers/Dashboard/Dashboard'));
const Associates = lazy(() => import('../../containers/Associates/Associates'));
const CharityApproval = lazy(() => import('../../containers/Referal/CharityApproval'));

export const ACCOUNT_ROUTES: AppRoute[] = [
    { path: '/profile', element: <Profile /> },
    { path: '/notifications', element: <Notifications /> },
    { path: '/audit-logs', element: <AuditLogs /> },
    { path: '/user-home', element: <VenueSelection /> },
    { path: '/venue-selection', element: <VenueSelection /> },
    { path: '/dashboard', element: <Dashboard /> },
    { path: '/announcements', element: <AnnouncementsTable /> },
    { path: '/associates', element: <Associates />, withAppShell: true },
    { path: '/charity-approval', element: <CharityApproval /> },
    { path: '/standardization-services', element: <StandardizationServicesPage />, withAppShell: true },
];
